import adminApiClient from './adminApiClient';

const adminAnalyticsService = {
  getAdminStats: () => adminApiClient.get('/api/admin/stats'),
  getSubscriptionStats: () => adminApiClient.get('/api/subscriptions/admin/stats'),
  getGrowth: () => adminApiClient.get('/api/admin/growth'),
  getBillingAdminStats: () => adminApiClient.get('/api/billing/admin/stats'),
};

export default adminAnalyticsService;
